"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostClientSendNotify = void 0;
const Base_1 = require("./Base");
exports.PostClientSendNotify = {
    url: Base_1.URL_BASE + "/ClientSendNotify",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostClientSendNotify.js.map